import { inject, PLATFORM } from 'aurelia-framework';
import { DataService } from './services/data-service';
import { IoLink } from './services/io-link';


@inject(DataService, IoLink)
export class App {

	/** Component methods **/
	contructor(ds, ioLink){
		this.ds = ds; this.ioLink = ioLink

	}

	/** Router **/

	configureRouter(config, router){
		config.title 				= "Samantia";
		config.options.pushState	= true;
		config.options.root			= "/";

		// Mapping
		config.map([
			// Default
			{ route:'/', redirect:'models'},
			// Models
			{
				route:'models', name: 'models',
				moduleId: PLATFORM.moduleName('machines/ai5-machines'),
				title:'Models'
			},
			{
				route:'models/template/', name: 'models.templates',
				moduleId: PLATFORM.moduleName('machines/machine-templates'),
				title:'Choose Template'
			},
			{
				route:'models/:id/dataset', name: 'models.dataset',
				moduleId: PLATFORM.moduleName('machines/machine-dataset'),
				title:'Select Dataset'
			},
			// ---> new machine training dataset
			{
				route:'models/:id/dataset/new', name: 'models.dataset-new',
				moduleId: PLATFORM.moduleName('machines/machine-dataset-new'),
				title:'New Dataset'
			},
			{
				route:'models/:id/settings', name: 'models.settings',
				moduleId: PLATFORM.moduleName('machines/machine-settings'),
				title:'Training Settings'
			},
			{
				route:'models/:id/confirm',
				name: 'models.confirm',
				moduleId: PLATFORM.moduleName('machines/machine-confirm'),
				title:'Summary'
			},
			{
				route:'models/:id/data',
				name: 'models.data',
				moduleId: PLATFORM.moduleName('machines/machine-data'),
				title:'Model'
			},

			// Re-train model
			{
				route:'models/:id/re-train',
				name: 'models.retrain',
				moduleId: PLATFORM.moduleName('machines/machine-retrain'),
				title:'Re-Train'
			},

			
			// --- > Predictions (model actions)
			{
				route:'models/:id/prediction',
				name: 'models.prediction',
				moduleId: PLATFORM.moduleName('machines/machine-prediction'),
				title:'Prediction'
			},

			{
				route:'models/:id/prediction/:pid',
				name: 'models.archive-prediction',
				moduleId: PLATFORM.moduleName('machines/machine-prediction'),
				title:'Prediction'
			},
			

			{
				route:'models/:id/simulation',
				name: 'models.simulation',
				moduleId: PLATFORM.moduleName('machines/machine-simulation'),
				title:'Simulation'
			},

			{
				route:'models/:id/simulation/:pid',
				name: 'models.archive-simulation',
				moduleId: PLATFORM.moduleName('machines/machine-simulation'),
				title:'Archive Simulation'
			},

			{
				route:'models/:id/forecast',
				name: 'models.forecast',
				moduleId: PLATFORM.moduleName('machines/machine-forecast'),
				title:'Forecast'
			},

			{
				route:'models/:id/forecast/:pid',
				name: 'models.archive-forecast',
				moduleId: PLATFORM.moduleName('machines/machine-forecast'),
				title:'Archive Forecast'
			},

			{
				route:'models/:id/insights',
				name: 'models.insights',
				moduleId: PLATFORM.moduleName('machines/machine-insights'),
				title:'Insights'
			},

			{
				route:'models/:id/append-data',
				name: 'models.append',
				moduleId: PLATFORM.moduleName('machines/machine-append-data'),
				title:'Append'
			},

			{
				route:'models/:id/archive',
				name: 'models.archive',
				moduleId: PLATFORM.moduleName('machines/machine-archive'),
				title:'Archive'
			},

			{
				route:'models/:id/bulk-prediction',
				name: 'models.bulk',
				moduleId: PLATFORM.moduleName('machines/machine-bulk-prediction'),
				title:'Bullk Prediction'
				
			},

			{
				route:'models/:id/bulk-prediction/:pid',
				name: 'models.archive-bulk',
				moduleId: PLATFORM.moduleName('machines/machine-bulk-prediction'),
				title:'Archive Bullk Prediction'
				
			},
			
			// Datasets
			{
				route:':uid/datasets', name: 'datasets',
				moduleId: PLATFORM.moduleName('datasets/datasets'),
				title:'Datasets'
			},
			// ---> create new dataset from datasets
			{
				route:':uid/datasets/new', name: 'datasets.create-dataset',
				moduleId: PLATFORM.moduleName('datasets/create-dataset'),
				title:'New Dataset'
			},

			// Templates
			{
				route:'templates', name: 'templates',
				moduleId: PLATFORM.moduleName('templates/templates'),
				title:'Templates'
			},
			// Profile
			{
				route:'profile', name: 'profile',
				moduleId: PLATFORM.moduleName('profile/profile'),
				title:'Profile'
			},

			{
				route:'profile/account',
				name: 'profile.account',
				moduleId: PLATFORM.moduleName('profile/account'),
				title:'Account'
			},

			{
				route:'profile/account/info',
				name: 'profile.account-info',
				moduleId: PLATFORM.moduleName('profile/account-info'),
				title:'Account Info'
			},

			{
				route:'profile/account/info/:detail',
				name: 'profile.account-info-detail',
				moduleId: PLATFORM.moduleName('profile/account-info-detail'),
				title:'Account Info'
			},
			// Profile - subscription
			{
				route:'profile/subscription',
				name: 'profile.settings-subscription',
				moduleId: PLATFORM.moduleName('profile/settings-subscription'),
				title:'Settings subscription'
			},

			{
				route:'profile/subscription/manage',
				name: 'profile.settings-subscription-manage',
				moduleId: PLATFORM.moduleName('profile/settings-subscription-manage'),
				title:'Subsciprtion manage'
			},

			{
				route:'profile/subscription/manage/cancel',
				name: 'profile.settings-subscription-cancel',
				moduleId: PLATFORM.moduleName('profile/settings-subscription-cancel'),
				title:'Subsciprtion cancel'
			},

			{
				route:'profile/subscription/usage',
				name: 'profile.settings-subscription-usage',
				moduleId: PLATFORM.moduleName('profile/settings-subscription-usage'),
				title:'Subsciprtion usage'
			},
			// --Billing ---

			{
				route:'profile/billing',
				name: 'profile.settings-billing',
				moduleId: PLATFORM.moduleName('profile/settings-billing'),
				title:'Billing'
			},

			{
				route:'profile/billing/payments',
				name: 'profile.settings-billing-payments',
				moduleId: PLATFORM.moduleName('profile/billing-payments'),
				title:'Billing'
			},

			{
				route:'profile/billing/history',
				name: 'profile.settings-billing-history',
				moduleId: PLATFORM.moduleName('profile/billing-history'),
				title:'Billing'
			},
			
			
		]);
	}
}
